<template>
  <div class="lateral-sliding">
    <div class="lateral-sliding-item">
      <!--<div class="slider_item">-->
        <slot></slot>
      <!--</div>-->
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Slider',
    display: '横向商品列表',
    data () {
      return {
        preCls: 'mc-slider',
      }

    }
  }
</script>

<style scoped>
  .lateral-sliding {
    display: flex;
    overflow-y: hidden;
    overflow-x: visible;
  }
  .lateral-sliding ::-webkit-scrollbar {
    display: none;
  }

  .lateral-sliding-item {
    display: flex;
    /*background-color: yellow;*/
  }

</style>



// WEBPACK FOOTER //
// src/components/slider/slider.vue